module.exports = __webpack_public_path__ + "app/principal/widgets/draggable-table-CPP5GiTl.html";